module.exports = {"pagination":{}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/aws-sdk/apis/runtime.lex-2016-11-28.paginators.json
// module id = 438
// module chunks = 0